import { useLanguageCtx } from '../../../store/providers/LanguageContext';
import { useScrollCtx } from '../../../store/providers/ScrollContext';
// import ChangeableHeader from '../../Molecules/ChangeableHeader/ChangeableHeader';
import ChangeableHeaderV2 from '../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2';
import AllNewsSection from '../../Organisms/AllNewsSection/AllNewsSection';
import content from "./content";

const AllNews = () => {
  const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();
  return (
		<>
			<ChangeableHeaderV2
        appearSecondNavbar={dropdownHeader}
        titleBanner={content[language].header_title}
        spanTitleYellow={content[language].header_span_title}
      />
			<AllNewsSection />
		</>
	);
}

export default AllNews
